import Label from "components/Label/Label";
import React, { FC, useState, useEffect, useRef } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import Radio from "shared/Radio/Radio";
import Select from "../../shared/Select/Select";
import useCartStore from "../../store/cartStore";
import useEshop from "../../store/eshopStore";

// Declare GLS widget types
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'gls-dpm-dialog': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement> & {
        country?: string;
        language?: string;
        id?: string;
      }, HTMLElement>;
    }
  }
}

interface Props {
  isActive: boolean;
  /* onCloseActive: () => void;
  onOpenActive: () => void;

   */
}

function formatPrice(price: number) {
  // Convert the price to a string with fixed two decimal places
  let priceStr = price.toFixed(2);

  // Split the string into the whole number and decimal parts
  let parts = priceStr.split('.');
  let integerPart = parts[0];
  let decimalPart = parts[1];

  // Add spaces for thousands
  let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Combine the parts with a comma as the decimal delimiter
  return formattedIntegerPart + ',' + decimalPart;
}

const PaymentMethod: FC<Props> = ({
  isActive,
  /* onCloseActive,
  onOpenActive,*/
}) => {
  const [mothodActive, setMethodActive] = useState<
    "Credit-Card" | "Internet-banking" | "Wallet"
  >("Credit-Card");

  const cart = useCartStore();
  const chosenDelivery = useCartStore((state) => state.chosenDelivery);
  const deliveryPoint = useCartStore((state) => state.deliveryPoint);
  const setDeliveryPoint = useCartStore((state) => state.setDeliveryPoint);
  const clearDeliveryPoint = useCartStore((state) => state.clearDeliveryPoint);
  const eshop = useEshop((state) => state.settings);

  const glsDialogRef = useRef<HTMLElement | null>(null);
  const [glsScriptLoaded, setGlsScriptLoaded] = useState(false);

  // Check if current delivery option is pickup point
  const isPickupPointDelivery = eshop?.deliveryOptions[Number(chosenDelivery)]?.isPickupPoint ?? false;

  // Load GLS widget script
  useEffect(() => {
    if (!document.querySelector('script[src*="gls-dpm.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://map.gls-slovakia.com/widget/gls-dpm.js';
      script.type = 'module';
      script.onload = () => setGlsScriptLoaded(true);
      document.body.appendChild(script);
    } else {
      setGlsScriptLoaded(true);
    }
  }, []);

  // Setup GLS dialog event listener
  useEffect(() => {
    const glsDialog = document.getElementById('gls-map-dialog');
    if (glsDialog) {
      glsDialogRef.current = glsDialog;

      const handleChange = (e: any) => {
        const selectedPoint = e.detail;
        if (selectedPoint) {
          const fullAddress = `${selectedPoint.contact.address}, ${selectedPoint.contact.postalCode} ${selectedPoint.contact.city}`;
          setDeliveryPoint({
            id: selectedPoint.id,
            name: selectedPoint.name,
            address: fullAddress
          });
        }
      };

      glsDialog.addEventListener('change', handleChange);
      return () => glsDialog.removeEventListener('change', handleChange);
    }
  }, [glsScriptLoaded, setDeliveryPoint]);

  // Clear delivery point when switching away from pickup point delivery
  useEffect(() => {
    if (!isPickupPointDelivery && deliveryPoint) {
      clearDeliveryPoint();
    }
  }, [isPickupPointDelivery, deliveryPoint, clearDeliveryPoint]);

  const openGlsDialog = () => {
    const glsDialog = document.getElementById('gls-map-dialog') as any;
    if (glsDialog && typeof glsDialog.showModal === 'function') {
      glsDialog.showModal();
    }
  };

  const handleSelectChangeDelivery = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    cart.setChosenDelivery(value)
    // console.log("chosen delivery value",value)
    // console.log("chosen delivery ",chosenDelivery)
    // console.log(typeof chosenDelivery)
  };

  const handleSelectChangePayment = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    cart.setChosenPayment(value)

  };


  const renderPaymentMethod = () => {

    return (
      <div className="border border-slate-200 dark:border-slate-700 rounded-xl " style={{backgroundColor:"#fafafa"}}>
        <div className="p-6 flex flex-col sm:flex-row items-start" style={{backgroundColor:"#eaeaea"}}>
          <span className="hidden sm:block">
            <svg
              className="w-6 h-6 text-slate-700 dark:text-slate-400 mt-0.5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.92969 15.8792L15.8797 3.9292"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.1013 18.2791L12.3013 17.0791"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.793 15.5887L16.183 13.1987"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.60127 10.239L10.2413 3.599C12.3613 1.479 13.4213 1.469 15.5213 3.569L20.4313 8.479C22.5313 10.579 22.5213 11.639 20.4013 13.759L13.7613 20.399C11.6413 22.519 10.5813 22.529 8.48127 20.429L3.57127 15.519C1.47127 13.419 1.47127 12.369 3.60127 10.239Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 21.9985H22"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <div className="sm:ml-8" >
            <h3 className=" text-slate-700 dark:text-slate-400 flex ">
              <span className="uppercase tracking-tight font-bold ">Doprava a platba </span>

            </h3>

          </div>

        </div>

        <div
            className={`border-t border-slate-200 dark:border-slate-700 px-6 py-7 space-y-6 ${
                isActive ? "block" : "hidden"
            }`}
        >
          {cart.isDeliveryFree && <span className="text-red-500">Dopravu máte zadarmo</span>}
          {/* ==================== */}
          <div style={{marginBottom: "10px"}}>
            <Label>Vyberte dopravu</Label>
            <Select className="mt-1.5" name="strih" onChange={handleSelectChangeDelivery} value={chosenDelivery}>
              {    // @ts-ignore
                eshop?.deliveryOptions.map((option) => (
                  // @ts-ignore
                  <option key={option.id} value={option.id}>
                    {option.name} {!cart.isDeliveryFree &&<>({formatPrice(option.cost)} €)</>}
                  </option>
              ))}
            </Select>
          </div>

          {/* GLS/AlzaBox pickup point selection */}
          {isPickupPointDelivery && (
            <div style={{marginBottom: "10px", padding: "15px", backgroundColor: "#f0f7ff", borderRadius: "8px", border: "1px solid #cce0ff"}}>
              <Label>Miesto doručenia</Label>
              <button
                type="button"
                onClick={openGlsDialog}
                className="mt-2 w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
                style={{backgroundColor: "#2563eb"}}
              >
                Vybrať odberné miesto GLS/AlzaBox
              </button>

              {deliveryPoint && (
                <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <div className="text-green-800">
                    <strong>Vybrané miesto:</strong> {deliveryPoint.name}<br/>
                    <strong>Adresa:</strong> {deliveryPoint.address}
                  </div>
                  <button
                    type="button"
                    onClick={() => clearDeliveryPoint()}
                    className="mt-2 text-sm text-red-600 hover:text-red-800 underline"
                  >
                    Zrušiť výber
                  </button>
                </div>
              )}

              {!deliveryPoint && (
                <div className="mt-2 text-sm text-orange-600">
                  * Prosím, vyberte odberné miesto pre dokončenie objednávky
                </div>
              )}
            </div>
          )}

          {/* GLS Dialog - hidden, opens as modal */}
          {/* @ts-ignore */}
          <gls-dpm-dialog country="sk" language="sk" id="gls-map-dialog"></gls-dpm-dialog>

          <div style={{marginBottom: "10px"}}>
            <Label>Vyberte spôsob platby</Label>
            <Select className="mt-1.5" name="strih"  onChange={handleSelectChangePayment} >
              {


                    // @ts-ignore
                    //.filter(option => option.visible_in_delivery.includes(chosenDelivery)) // Filter options based on chosenDelivery
                    // @ts-ignore
                eshop?.paymentOptions.filter(option => option.visible_in_delivery.includes(Number(chosenDelivery ?? 0))).map((option) => (



                        // @ts-ignore
                        <option key={option.id} value={option.id}>
                          {option.name} {!cart.isDeliveryFree && <>({formatPrice(option.cost)} €)</>}
                        </option>


                    ))

              }
            </Select>
          </div>

          {/*
          <div>{renderDebitCredit()}</div>
          <div>{renderInterNetBanking()}</div>
          <div>{renderWallet()}</div>
          */}

          {/*
          <div className="flex pt-6">
            <ButtonPrimary
                className="w-full max-w-[240px]"
                onClick={onCloseActive}
            >
              Confirm order
            </ButtonPrimary>
            <ButtonSecondary className="ml-3" onClick={onCloseActive}>
              Cancel
            </ButtonSecondary>
          </div>
          */}
        </div>
      </div>
    );
  };

  return renderPaymentMethod();
};

export default PaymentMethod;
